let processConfig = process.env;

// Set basic properties
let config = {
    backend_port: processConfig.REACT_APP_SECURAZE_WEBUI_PORT || 44300,
    backend_domain: processConfig.REACT_APP_SECURAZE_WEBUI_DOMAIN || `http://test.cloud.securaze.com`,
    backend_static: processConfig.REACT_APP_SECURAZE_WEBUI_STATIC || `http://test.cloud.securaze.com:${44300}/static`,
    environment: processConfig.REACT_APP_SECURAZE_WEBUI_ENV || 'stage',
    hubspot_id: processConfig.REACT_APP_HUBSPOT_ID || '',
    timezone: processConfig.REACT_APP_TIMEZONE || 'Europe/Vienna',
    web: processConfig.REACT_APP_SECURAZE_WEBUI_WEBDOMAIN || 'http://test-webui-eu.securaze.com',
    upload: {
        media: {
            resizeImages: processConfig.REACT_APP_UPLOAD_MEDIA_RESIZE_IMAGES ?? true,
            resizeToWidth: processConfig.REACT_APP_UPLOAD_MEDIA_RESIZE_TO_WIDTH ?? 2160,
            compressImages: processConfig.REACT_APP_UPLOAD_MEDIA_COMPRESS_IMAGES ?? false,
            compressionQuality: processConfig.REACT_APP_UPLOAD_MEDIA_COMPRESSION_QUALITY ?? 90,
            convertHeicImages: processConfig.REACT_APP_UPLOAD_MEDIA_CONVERT_HEIC_IMAGES ?? true,
            convertOnlyMainImageFromHeic: processConfig.REACT_APP_UPLOAD_MEDIA_CONVERT_ONLY_MAIN_IMAGE_FROM_HEIC ?? true,
            supportHeicPreview: processConfig.REACT_APP_UPLOAD_MEDIA_SUPPORT_HEIC_PREVIEW ?? false,
            maxFiles: processConfig.REACT_APP_UPLOAD_MEDIA_MAX_FILES ?? 15,
            maxSizePerImage: processConfig.REACT_APP_UPLOAD_MEDIA_MAX_SIZE_PER_IMAGE ?? 20, // MiBs
        },
    },
}

// Create calculated properties
config = {
    ...config,
    backend_url: config.backend_domain + ':' + config.backend_port,
}

export default config;
